export const customersTranslations = {
  // Main headings
  'customers.title': {
    en: 'Customers',
    fi: 'Asiakkuudet'
  },
  'customers.activeCustomers': {
    en: 'active customers',
    fi: 'aktiivista asiakkuutta'
  },
  
  // Table headers
  'customers.customerName': {
    en: 'Customer Name',
    fi: 'Asiakkaan nimi'
  },
  'customers.customerRep': {
    en: 'Customer Representative',
    fi: 'Asiakasvastaava'
  },
  'customers.type': {
    en: 'Type',
    fi: 'Tyyppi'
  },
  
  // Types
  'customers.typeCustomer': {
    en: 'Customer',
    fi: 'Asiakas'
  },
  'customers.typeAssociate': {
    en: 'Associate',
    fi: 'Yhteistyökumppani'
  },
  'customers.typeInactive': {
    en: 'Inactive',
    fi: 'Ei aktiivinen'
  },
  
  // Actions
  'customers.addCustomer': {
    en: 'Add Customer',
    fi: 'Perusta asiakkuus'
  },
  
  // Search
  'customers.searchPlaceholder': {
    en: 'Search by name, business code, or type...',
    fi: 'Hae nimellä, Y-tunnuksella tai tyypillä...'
  },
  'customers.priceListSearchPlaceholder': {
    en: 'Search by name or description...',
    fi: 'Hae nimellä tai kuvauksella...'
  },
  
  // Results
  'customers.noResults': {
    en: 'No results for',
    fi: 'Ei tuloksia hakusanalla'
  },
  'customers.customerCount': {
    en: 'customers',
    fi: 'asiakkuutta'
  },
  'customers.noCustomersFound': {
    en: 'No customers found',
    fi: 'Asiakkaita ei löytynyt'
  },
  
  // Basic info section
  'customers.basicInfo': {
    en: 'Basic Information',
    fi: 'Perustiedot'
  },
  'customers.basicInfoDescription': {
    en: 'These are required fields.',
    fi: 'Nämä ovat pakollisia tietoja.'
  },
  'customers.existingCustomerWarning': {
    en: 'This customer already exists – do you want to use it?',
    fi: 'Tämä asiakas löytyy jo – haluatko käyttää sitä?'
  },
  'customers.goToExistingCustomer': {
    en: 'Go to existing customer',
    fi: 'Siirry olemassa olevaan asiakkuuteen'
  },
  
  // Form fields
  'customers.nameLabel': {
    en: 'Customer Name',
    fi: 'Asiakkaan nimi'
  },
  'customers.namePlaceholder': {
    en: 'e.g. Company Ltd',
    fi: 'esim. Yritys Oy'
  },
  'customers.businessCodeLabel': {
    en: 'Business ID',
    fi: 'Y-tunnus'
  },
  'customers.businessCodePlaceholder': {
    en: 'e.g. 1234567-8',
    fi: 'esim. 1234567-8'
  },
  'customers.customerRepLabel': {
    en: 'Account Manager',
    fi: 'Asiakasvastaava'
  },
  'customers.selectCustomerRep': {
    en: 'Select account manager',
    fi: 'Valitse asiakasvastaava'
  },
  'customers.typeLabel': {
    en: 'Type',
    fi: 'Tyyppi'
  },
  
  // Invoice form
  'customers.invoiceDescription': {
    en: 'Enter the billing address where invoices will be sent.',
    fi: 'Anna laskutusosoite, johon laskut lähetetään.'
  },
  'customers.invoiceNameLabel': {
    en: 'Name',
    fi: 'Nimi'
  },
  'customers.invoiceNamePlaceholder': {
    en: 'e.g. Technology Ltd / Billing',
    fi: 'esim. Teknologia Oy / Laskutus'
  },
  'customers.invoiceAddressLabel': {
    en: 'Street Address',
    fi: 'Katuosoite'
  },
  'customers.invoiceAddressPlaceholder': {
    en: 'e.g. Example Street 1',
    fi: 'esim. Esimerkkikatu 1'
  },
  'customers.invoicePostalCodeLabel': {
    en: 'Postal Code',
    fi: 'Postinumero'
  },
  'customers.invoicePostalCodePlaceholder': {
    en: 'e.g. 00100',
    fi: 'esim. 00100'
  },
  'customers.invoiceCityLabel': {
    en: 'City',
    fi: 'Postitoimipaikka'
  },
  'customers.invoiceCityPlaceholder': {
    en: 'e.g. Helsinki',
    fi: 'esim. Helsinki'
  },
  'customers.invoiceCountryLabel': {
    en: 'Country',
    fi: 'Maa'
  },
  'customers.invoiceCountryPlaceholder': {
    en: 'e.g. Finland',
    fi: 'esim. Suomi'
  },
  'customers.invoiceEmailLabel': {
    en: 'Email Address',
    fi: 'Sähköpostiosoite'
  },
  'customers.invoiceEmailPlaceholder': {
    en: 'e.g. billing@company.com',
    fi: 'esim. laskutus@yritys.fi'
  },
  'customers.contractNumberLabel': {
    en: 'Contract Number',
    fi: 'Sopimusnumero'
  },
  'customers.contractNumberPlaceholder': {
    en: 'e.g. SOP-2024-001',
    fi: 'esim. SOP-2024-001'
  },
  'customers.accountingRefLabel': {
    en: 'Accounting Reference',
    fi: 'Tiliöintiviite'
  },
  'customers.accountingRefPlaceholder': {
    en: 'e.g. 1234-5678',
    fi: 'esim. 1234-5678'
  },
  'customers.buyerRefLabel': {
    en: 'Buyer Reference',
    fi: 'Ostajan viitetunniste'
  },
  'customers.buyerRefPlaceholder': {
    en: 'e.g. BUY-001',
    fi: 'esim. BUY-001'
  },
  'customers.paymentTermLabel': {
    en: 'Payment Term',
    fi: 'Maksuehto'
  },
  'customers.complaintTimeLabel': {
    en: 'Reminder Time',
    fi: 'Huomautusaika',
  },
  'customers.days': {
    en: 'days',
    fi: 'päivää'
  },
  'customers.invoiceNoteLabel': {
    en: 'Invoice Additional Text',
    fi: 'Laskun lisäteksti'
  },
  'customers.invoiceNotePlaceholder': {
    en: 'Optional additional text for the invoice',
    fi: 'Vapaaehtoinen lisäteksti laskulle'
  },
  'customers.cancel': {
    en: 'Cancel',
    fi: 'Peruuta'
  },
  'customers.save': {
    en: 'Save',
    fi: 'Tallenna'
  },
  'customers.ready': {
    en: 'Ready',
    fi: 'Valmis'
  },
  
  // E-invoice form
  'customers.eInvoiceDescription': {
    en: 'Fill in the e-invoice details for electronic invoicing.',
    fi: 'Täytä verkkolaskutuksen tiedot sähköistä laskutusta varten.'
  },
  'customers.operatorCodeLabel': {
    en: 'Operator Code',
    fi: 'Operaattoritunnus'
  },
  'customers.selectOperator': {
    en: 'Select operator',
    fi: 'Valitse operaattori'
  },
  'customers.eInvoiceAddressLabel': {
    en: 'E-invoice Address',
    fi: 'Verkkolaskuosoite'
  },
  'customers.eInvoiceAddressPlaceholder': {
    en: 'e.g. 003712345678',
    fi: 'esim. 003712345678'
  },
  'customers.euStandardLabel': {
    en: 'Invoice uses EU standard',
    fi: 'Laskulla EU-standardi käytössä'
  },
  'customers.euStandardDescription': {
    en: 'Invoice will be sent in EU standard format',
    fi: 'Lasku lähetetään EU-standardin mukaisessa muodossa'
  },
  
  // Billing section
  'customers.billing': {
    en: 'Billing',
    fi: 'Laskutus'
  },
  'customers.priceList': {
    en: 'Price List',
    fi: 'Hinnasto'
  },
  'customers.priceListMissing': {
    en: 'Price list missing',
    fi: 'Hinnasto puuttuu'
  },
  'customers.priceListMissingDescription': {
    en: 'Create or select an existing price list for this customer.',
    fi: 'Luo tai valitse olemassa oleva hinnasto tätä asiakkuutta varten.'
  },
  'customers.createPriceList': {
    en: 'Create price list',
    fi: 'Luo hinnasto'
  },
  'customers.createNew': {
    en: 'Create new',
    fi: 'Luo uusi'
  },
  'customers.selectExisting': {
    en: 'Select existing',
    fi: 'Valitse olemassa oleva'
  },
  'customers.inUse': {
    en: 'In use',
    fi: 'Käytössä'
  },
  'customers.validFrom': {
    en: 'Valid from',
    fi: 'Voimassa'
  },
  'customers.onwards': {
    en: 'onwards',
    fi: 'alkaen'
  },
  'customers.moreItems': {
    en: 'more...',
    fi: 'lisää...'
  },
  'customers.priceListTypeHourly': {
    en: 'Hourly',
    fi: 'Tuntihinta'
  },
  'customers.priceListTypeFixed': {
    en: 'Fixed',
    fi: 'Kiinteä'
  },
  'customers.priceListTypeMixed': {
    en: 'Mixed',
    fi: 'Mixed'
  },
  'customers.otherBillingInfo': {
    en: 'Other billing information',
    fi: 'Muut laskutustiedot'
  },
  'customers.billingAddress': {
    en: 'Billing Address',
    fi: 'Laskutusosoite'
  },
  'customers.eInvoicing': {
    en: 'E-Invoicing',
    fi: 'Verkkolaskutus'
  },
  'customers.noBillingAddress': {
    en: 'No billing address',
    fi: 'Ei laskutusosoitetta'
  },
  'customers.noEInvoicing': {
    en: 'No e-invoicing details',
    fi: 'Ei verkkolaskutustietoja'
  },
  
  // Contact info section
  'customers.contactInfo': {
    en: 'Contact Information',
    fi: 'Yhteystiedot'
  },
  'customers.contactInfoDescription': {
    en: 'Contact person and location details for the customer.',
    fi: 'Asiakkaan yhteyshenkilön ja toimipaikan tiedot.'
  },
  'customers.contactNameLabel': {
    en: 'Name',
    fi: 'Nimi'
  },
  'customers.contactNamePlaceholder': {
    en: 'Contact person name',
    fi: 'Yhteyshenkilön nimi'
  },
  'customers.addressLabel': {
    en: 'Street Address',
    fi: 'Katuosoite'
  },
  'customers.addressPlaceholder': {
    en: 'e.g. Mannerheimintie 1',
    fi: 'esim. Mannerheimintie 1'
  },
  'customers.postalCodeLabel': {
    en: 'Postal Code',
    fi: 'Postinumero'
  },
  'customers.postalCodePlaceholder': {
    en: '00100',
    fi: '00100'
  },
  'customers.cityLabel': {
    en: 'City',
    fi: 'Postitoimipaikka'
  },
  'customers.cityPlaceholder': {
    en: 'Helsinki',
    fi: 'Helsinki'
  },
  'customers.countryLabel': {
    en: 'Country',
    fi: 'Maa'
  },
  'customers.phoneLabel': {
    en: 'Phone',
    fi: 'Puhelin'
  },
  'customers.phonePlaceholder': {
    en: '+358 40 123 4567',
    fi: '+358 40 123 4567'
  },
  'customers.emailLabel': {
    en: 'Email',
    fi: 'Sähköposti'
  },
  'customers.emailPlaceholder': {
    en: 'company@example.com',
    fi: 'yritys@esimerkki.fi'
  },
  'customers.websiteLabel': {
    en: 'Website',
    fi: 'WWW-osoite'
  },
  'customers.websitePlaceholder': {
    en: 'https://www.company.com',
    fi: 'https://www.yritys.fi'
  },
  'customers.contactDetails': {
    en: 'Contact Details',
    fi: 'Yhteystiedot'
  },
  
  // Create customer view
  'customers.createTitle': {
    en: 'Create Customer',
    fi: 'Asiakkuuden perustaminen'
  },
  'customers.editTitle': {
    en: 'Edit Customer',
    fi: 'Asiakkuuden muokkaaminen'
  },
  'customers.back': {
    en: 'Back',
    fi: 'Takaisin'
  },
  'customers.basicInfoStep': {
    en: 'Basic Information',
    fi: 'Perustiedot'
  },
  'customers.billingStep': {
    en: 'Billing',
    fi: 'Laskutus'
  },
  'customers.ready': {
    en: 'Ready',
    fi: 'Valmis'
  },
  'customers.readyDescription': {
    en: 'Fill in at least basic information and billing details',
    fi: 'Täytä vähintään perustiedot ja laskutustiedot'
  },
  'customers.basicInfoComplete': {
    en: 'Basic information filled',
    fi: 'Perustiedot täytetty'
  },
  'customers.billingComplete': {
    en: 'Billing information filled',
    fi: 'Laskutustiedot täytetty'
  },
  'customers.allComplete': {
    en: 'All required information filled — ready to save',
    fi: 'Kaikki pakolliset tiedot täytetty — valmis tallennukseen'
  },
  'customers.fillBasicInfo': {
    en: 'Fill in customer name, business ID and account manager',
    fi: 'Täytä asiakkaan nimi, Y-tunnus ja asiakasvastaava'
  },
  'customers.fillBilling': {
    en: 'Fill in billing information',
    fi: 'Täytä laskutustiedot'
  },
  'customers.saveCustomer': {
    en: 'Save customer',
    fi: 'Tallenna asiakas'
  },
  'customers.customerSaved': {
    en: 'Customer saved',
    fi: 'Asiakas tallennettu'
  },
  'customers.customerUpdated': {
    en: 'Customer updated successfully',
    fi: 'Asiakas päivitetty onnistuneesti'
  },
  'customers.required': {
    en: 'Required',
    fi: 'Pakollinen'
  },
  
  // Price list form
  'customers.newVersionInfo': {
    en: 'You are creating a new version of the price list. The name, description, and price items have been copied from the previous version – edit as needed. Set a new valid from date to continue.',
    fi: 'Luot uuden version hinnastosta. Nimi, kuvaus ja hintatuotteet on kopioitu edelliseltä versiolta – muokkaa tarvittaessa. Aseta uusi voimassaolopäivä jatkaaksesi.'
  },
  'customers.descriptionLabel': {
    en: 'Description',
    fi: 'Kuvaus'
  },
  'customers.optional': {
    en: 'optional',
    fi: 'valinnainen'
  },
  'customers.priceListNamePlaceholder': {
    en: 'e.g. Standard 2025',
    fi: 'esim. Standard 2025'
  },
  'customers.priceListDescriptionPlaceholder': {
    en: 'Short description of the price list',
    fi: 'Lyhyt kuvaus hinnastosta'
  },
  'customers.priceListCustomerLabel': {
    en: 'Customer',
    fi: 'Asiakas'
  },
  'customers.priceListProjectLabel': {
    en: 'Project',
    fi: 'Projekti'
  },
  'customers.selectCustomerPlaceholder': {
    en: 'Select customer',
    fi: 'Valitse asiakas'
  },
  'customers.selectProjectPlaceholder': {
    en: 'Select project',
    fi: 'Valitse projekti'
  },
  'customers.validFromLabel': {
    en: 'Valid from',
    fi: 'Voimassa alkaen'
  },
  'customers.earliestDate': {
    en: 'Earliest possible date',
    fi: 'Aikaisin mahdollinen päivä'
  },
  'customers.priceItems': {
    en: 'Price items',
    fi: 'Hintatuotteet'
  },
  'customers.hourlyPricing': {
    en: 'Hourly Pricing',
    fi: 'Tuntihinnoittelu'
  },
  'customers.noPriceItems': {
    en: 'No price items yet.',
    fi: 'Ei hintatuotteita vielä.'
  },
  'customers.addHourlyOrFixed': {
    en: 'Add hourly rate or fixed price.',
    fi: 'Lisää tuntihinta tai kiinteä hinta.'
  },
  'customers.addPriceItem': {
    en: 'Add price item',
    fi: 'Lisää hintatuote'
  },
  'customers.selectPricingType': {
    en: 'Select pricing type',
    fi: 'Valitse hinnoittelutyyppi'
  },
  'customers.roleBasedPricing': {
    en: 'Price group based pricing',
    fi: 'Hintaryhmäpohjainen hinnoittelu'
  },
  'customers.roleBasedPricingDesc': {
    en: 'Set different prices for different price groups',
    fi: 'Aseta eri hinta eri hintaryhmille'
  },
  'customers.hourlyRate': {
    en: 'Hourly rate',
    fi: 'Tuntihinta'
  },
  'customers.role': {
    en: 'Price group',
    fi: 'Hintaryhmä'
  },
  'customers.roleMultiple': {
    en: 's',
    fi: 'a'
  },
  'customers.rolePlaceholder': {
    en: 'e.g. Developer',
    fi: 'esim. Developer'
  },
  'customers.addRole': {
    en: 'Add price group',
    fi: 'Lisää hintaryhmä'
  },
  'customers.serviceName': {
    en: 'Service name',
    fi: 'Palvelun nimi'
  },
  'customers.serviceNamePlaceholder': {
    en: 'e.g. Monthly package',
    fi: 'esim. Kuukausipaketti'
  },
  'customers.priceEur': {
    en: 'Price €',
    fi: 'Hinta €'
  },
  'customers.savePriceList': {
    en: 'Save price list',
    fi: 'Tallenna hinnasto'
  },
  
  // Price list selector
  'customers.selectExistingPriceListDesc': {
    en: 'Select an existing price list for the customer.',
    fi: 'Valitse olemassa oleva hinnasto asiakkuudelle.'
  },
  'customers.noPriceListsAvailable': {
    en: 'No price lists available.',
    fi: 'Ei hinnastoja saatavilla.'
  },
  
  // Versioning dialog
  'customers.howToMakeChange': {
    en: 'How do you want to make the change?',
    fi: 'Miten haluat tehdä muutoksen?'
  },
  'customers.selectModificationMethod': {
    en: 'Select the way you want to modify the price list.',
    fi: 'Valitse tapa, jolla haluat muokata hinnastoa.'
  },
  'customers.newVersionRequiresDate': {
    en: 'New version requires a new valid from date. The old version will be archived and kept as historical data.',
    fi: 'Uusi versio tarvitsee uuden voimassaolopäivän. Vanha versio arkistoidaan ja säilytetään historiatietona.'
  },
  'customers.editCurrent': {
    en: 'Edit current',
    fi: 'Muokkaa nykyistä'
  },
  'customers.cannotEditInUsePriceList': {
    en: 'Price list in use cannot be edited directly.',
    fi: 'Käytössä olevaa hinnastoa ei voi muokata suoraan.'
  },
  'customers.editCurrentDirectly': {
    en: 'Edit the current price list directly. Changes take effect immediately.',
    fi: 'Muokkaa suoraan nykyistä hinnastoa. Muutos astuu voimaan heti.'
  },
  'customers.continue': {
    en: 'Continue',
    fi: 'Jatka'
  },
  
  // Price list actions
  'customers.newPriceList': {
    en: 'New price list',
    fi: 'Uusi hinnasto'
  },
  'customers.newPriceListVersion': {
    en: 'New price list version',
    fi: 'Uusi versio hinnastosta'
  },
  'customers.editPriceList': {
    en: 'Edit price list',
    fi: 'Muokkaa hinnastoa'
  },
  'customers.selectPriceList': {
    en: 'Select price list',
    fi: 'Valitse hinnasto'
  },
  'customers.changePriceList': {
    en: 'Change',
    fi: 'Vaihda'
  },
  'customers.priceListSaved': {
    en: 'Price list saved',
    fi: 'Hinnasto tallennettu'
  },
  'customers.priceListSavedSuccessfully': {
    en: 'The price list has been saved successfully.',
    fi: 'Hinnasto on tallennettu onnistuneesti.'
  },
  'customers.priceListSelected': {
    en: 'Price list selected',
    fi: 'Hinnasto valittu'
  },
  'customers.hasBeenSelected': {
    en: 'has been selected',
    fi: 'on valittu'
  },
  
  // Price lists view
  'customers.priceLists': {
    en: 'Price Lists',
    fi: 'Hinnastot'
  },
  'customers.priceListsCount': {
    en: 'price lists',
    fi: 'hinnastoa'
  },
  'customers.noPriceLists': {
    en: 'No price lists. Create your first price list.',
    fi: 'Ei hinnastoja. Luo ensimmäinen hinnasto.'
  },
  'customers.projectsUseThis': {
    en: 'projects use this',
    fi: 'projektia käyttää tätä'
  },
  'customers.noProjects': {
    en: 'No projects.',
    fi: 'Ei projekteja.'
  },
  'customers.versionHistory': {
    en: 'Version History',
    fi: 'Versiohistoria'
  },
  'customers.noVersionHistory': {
    en: 'No version history.',
    fi: 'Ei versiohistoriaa.'
  },
  'customers.noPriceItemsYet': {
    en: 'No price items',
    fi: 'Ei hintatuotteita'
  },
  'customers.edit': {
    en: 'Edit',
    fi: 'Muokkaa'
  },
  'customers.newVersion': {
    en: 'New Version',
    fi: 'Uusi versio'
  },
  'customers.clone': {
    en: 'Clone',
    fi: 'Kloonaa'
  },
  'customers.delete': {
    en: 'Delete',
    fi: 'Poista'
  },
  'customers.priceListInUseCannotEdit': {
    en: 'Price list in use, cannot be edited. Create a new version.',
    fi: 'Hinnasto käytössä, ei voida muokata. Tee uusi versio.'
  },
  'customers.priceListInUseCannotDelete': {
    en: 'Price list in use, deletion not allowed.',
    fi: 'Hinnasto käytössä, poistaminen ei sallittu.'
  },
  'customers.priceListDeleted': {
    en: 'Price list deleted.',
    fi: 'Hinnasto poistettu.'
  },
  'customers.noDescription': {
    en: 'No description',
    fi: 'Ei kuvausta'
  },
  'customers.newPriceListTitle': {
    en: 'New Price List',
    fi: 'Uusi hinnasto'
  },
  'customers.editPriceListTitle': {
    en: 'Edit',
    fi: 'Muokkaa'
  },
  'customers.newVersionPriceListTitle': {
    en: 'New Version',
    fi: 'Uusi versio'
  },
  'customers.clonePriceListTitle': {
    en: 'Clone',
    fi: 'Kloonaa'
  },
};
